import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Shield, Activity, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Footer() {
  const [validatedCount, setValidatedCount] = useState(847231);
  const [isDisclosureOpen, setIsDisclosureOpen] = useState(false);
  useEffect(() => {
    // Slowly increment the counter to simulate live data
    const interval = setInterval(() => {
      setValidatedCount(prev => prev + Math.floor(Math.random() * 3));
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  return <footer className="bg-[#050505] text-white border-t border-gray-800 relative overflow-hidden" data-id="element-2436">
      {/* Background Grid */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(20,20,20,0.5)_1px,transparent_1px),linear-gradient(90deg,rgba(20,20,20,0.5)_1px,transparent_1px)] bg-[size:40px_40px] opacity-20 pointer-events-none" data-id="element-2437" />

      <div className="max-w-6xl mx-auto px-6 py-20 relative z-10" data-id="element-2438">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16" data-id="element-2439">
          <div className="col-span-1 md:col-span-2 lg:col-span-2" data-id="element-2440">
            <div className="flex items-center gap-3 mb-6" data-id="element-2441">
              <div className="w-8 h-8 flex items-center justify-center bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-sm" data-id="element-2442">
                <Shield className="w-5 h-5 text-[#FF0000]" data-id="element-2443" />
              </div>
              <h3 className="text-lg font-black tracking-tight uppercase" data-id="element-2444">
                ToxicDetector
              </h3>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed max-w-xs font-mono mb-8" data-id="element-2445">
              AI-powered forensic toxicity detection for safer conversations. We
              help you see what's really happening.
            </p>

            {/* Transparency Widget */}
            <div className="inline-flex flex-col bg-[#0A0A0A] border border-gray-800 rounded-lg p-4 max-w-xs" data-id="element-2446">
              <div className="flex items-center gap-2 mb-2" data-id="element-2447">
                <span className="relative flex h-2 w-2" data-id="element-2448">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#FF0000] opacity-75" data-id="element-2449"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-[#FF0000]" data-id="element-2450"></span>
                </span>
                <span className="text-[10px] uppercase tracking-widest text-gray-500 font-mono" data-id="element-2451">
                  Live Transparency
                </span>
              </div>
              <div className="text-2xl font-mono text-white font-bold tabular-nums" data-id="element-2452">
                {validatedCount.toLocaleString()}
              </div>
              <div className="text-xs text-gray-400 mt-1" data-id="element-2453">
                Total Relationships Validated
              </div>
            </div>
          </div>

          <div className="col-span-1 md:col-span-2 lg:col-span-3 grid grid-cols-1 sm:grid-cols-3 gap-8" data-id="element-2454">
            <div data-id="element-2455">
              <h4 className="font-bold mb-6 text-xs uppercase tracking-widest text-white" data-id="element-2456">
                Product
              </h4>
              <ul className="space-y-4 text-sm font-medium text-gray-400" data-id="element-2457">
                <li data-id="element-2458">
                  <a href="/#features" className="hover:text-[#FF0000] transition-colors" data-id="element-2459">
                    Features
                  </a>
                </li>
                <li data-id="element-2460">
                  <a href="/#pricing" className="hover:text-[#FF0000] transition-colors" data-id="element-2461">
                    Pricing
                  </a>
                </li>
                <li data-id="element-2462">
                  <a href="/#faq" className="hover:text-[#FF0000] transition-colors" data-id="element-2463">
                    FAQ
                  </a>
                </li>
                <li data-id="element-2464">
                  <Link to="/dashboard" className="hover:text-[#FF0000] transition-colors" data-id="element-2465">
                    Dashboard
                  </Link>
                </li>
              </ul>
            </div>

            <div data-id="element-2466">
              <h4 className="font-bold mb-6 text-xs uppercase tracking-widest text-white" data-id="element-2467">
                Corporate
              </h4>
              <ul className="space-y-4 text-sm font-medium text-gray-400" data-id="element-2468">
                <li data-id="element-2469">
                  <a href="/about" className="hover:text-[#FF0000] transition-colors" data-id="element-2470">
                    The Lab
                  </a>
                </li>
                <li data-id="element-2471">
                  <a href="/blog" className="hover:text-[#FF0000] transition-colors" data-id="element-2472">
                    Blog
                  </a>
                </li>
              </ul>
            </div>

            <div data-id="element-2473">
              <h4 className="font-bold mb-6 text-xs uppercase tracking-widest text-white" data-id="element-2474">
                Legal
              </h4>
              <ul className="space-y-4 text-sm font-medium text-gray-400" data-id="element-2475">
                <li data-id="element-2476">
                  <a href="/privacy" className="hover:text-[#FF0000] transition-colors" data-id="element-2477">
                    Privacy Policy
                  </a>
                </li>
                <li data-id="element-2478">
                  <a href="/terms" className="hover:text-[#FF0000] transition-colors" data-id="element-2479">
                    Terms of Service
                  </a>
                </li>
                <li data-id="element-2480">
                  <a href="mailto:support@toxicdetector.com" className="hover:text-[#FF0000] transition-colors" data-id="element-2481">
                    Contact Support
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Blog Posts — SEO Internal Links */}
        <div className="mb-12" data-id="element-2482">
          <h4 className="font-bold mb-6 text-xs uppercase tracking-widest text-white" data-id="element-2483">
            Latest Articles
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-2484">
            <a href="/blog/7-signs-of-gaslighting" className="text-sm text-gray-400 hover:text-[#FF0000] transition-colors" data-id="element-2485">
              7 Signs of Gaslighting in Your Relationship
            </a>
            <a href="/blog/is-your-ex-covert-narcissist" className="text-sm text-gray-400 hover:text-[#FF0000] transition-colors" data-id="element-2486">
              Is Your Ex a Covert Narcissist?
            </a>
            <a href="/blog/how-to-spot-passive-aggressive-texts" className="text-sm text-gray-400 hover:text-[#FF0000] transition-colors" data-id="element-2487">
              How to Spot Passive-Aggressive Texts
            </a>
            <a href="/blog/narcissism-and-gaslighting-explained" className="text-sm text-gray-400 hover:text-[#FF0000] transition-colors" data-id="element-2488">
              Narcissism & Gaslighting Explained
            </a>
            <a href="/blog/why-some-people-drain-you" className="text-sm text-gray-400 hover:text-[#FF0000] transition-colors" data-id="element-2489">
              Why Some People Drain You
            </a>
            <a href="/blog/emotional-drain-part-2" className="text-sm text-gray-400 hover:text-[#FF0000] transition-colors" data-id="element-2490">
              Emotional Drain: Part 2
            </a>
          </div>
        </div>

        {/* Language Selector — SEO Internal Links */}
        <div className="mb-12" data-id="element-2491">
          <h4 className="font-bold mb-4 text-xs uppercase tracking-widest text-white" data-id="element-2492">
            Available Languages
          </h4>
          <div className="flex flex-wrap gap-3" data-id="element-2493">
            <a href="/" className="text-xs text-gray-500 hover:text-white transition-colors px-3 py-1.5 border border-gray-800 rounded-md hover:border-gray-600" hrefLang="en" data-id="element-2494">
              English
            </a>
            <a href="/pt" className="text-xs text-gray-500 hover:text-white transition-colors px-3 py-1.5 border border-gray-800 rounded-md hover:border-gray-600" hrefLang="pt" data-id="element-2495">
              Português
            </a>
            <a href="/es" className="text-xs text-gray-500 hover:text-white transition-colors px-3 py-1.5 border border-gray-800 rounded-md hover:border-gray-600" hrefLang="es" data-id="element-2496">
              Español
            </a>
            <a href="/ja" className="text-xs text-gray-500 hover:text-white transition-colors px-3 py-1.5 border border-gray-800 rounded-md hover:border-gray-600" hrefLang="ja" data-id="element-2497">
              日本語
            </a>
            <a href="/ko" className="text-xs text-gray-500 hover:text-white transition-colors px-3 py-1.5 border border-gray-800 rounded-md hover:border-gray-600" hrefLang="ko" data-id="element-2498">
              한국어
            </a>
            <a href="/de" className="text-xs text-gray-500 hover:text-white transition-colors px-3 py-1.5 border border-gray-800 rounded-md hover:border-gray-600" hrefLang="de" data-id="element-2499">
              Deutsch
            </a>
            <a href="/fr" className="text-xs text-gray-500 hover:text-white transition-colors px-3 py-1.5 border border-gray-800 rounded-md hover:border-gray-600" hrefLang="fr" data-id="element-2500">
              Français
            </a>
            <a href="/hi" className="text-xs text-gray-500 hover:text-white transition-colors px-3 py-1.5 border border-gray-800 rounded-md hover:border-gray-600" hrefLang="hi" data-id="element-2501">
              हिन्दी
            </a>
            <a href="/id" className="text-xs text-gray-500 hover:text-white transition-colors px-3 py-1.5 border border-gray-800 rounded-md hover:border-gray-600" hrefLang="id" data-id="element-2502">
              Bahasa Indonesia
            </a>
          </div>
        </div>

        {/* Liability Disclosure - Collapsible */}
        <div className="bg-[#0A0A0A] border border-gray-800 rounded-xl mb-8 overflow-hidden" data-id="element-2503">
          <button onClick={() => setIsDisclosureOpen(prev => !prev)} className="w-full flex items-center justify-between p-6 text-left group cursor-pointer" data-id="element-2504">
            <h4 className="text-[#FF0000] text-xs font-bold uppercase tracking-widest" data-id="element-2505">
              Liability & Usage Disclosure
            </h4>
            <motion.div animate={{
            rotate: isDisclosureOpen ? 180 : 0
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} data-id="element-2506">
              <ChevronDown size={16} className="text-gray-500 group-hover:text-gray-300 transition-colors" data-id="element-2507" />
            </motion.div>
          </button>
          <AnimatePresence initial={false} data-id="element-2508">
            {isDisclosureOpen && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} className="overflow-hidden" data-id="element-2509">
                <div className="px-6 pb-6 text-xs text-gray-500 font-mono leading-relaxed space-y-2" data-id="element-2510">
                  <p data-id="element-2511">
                    ToxicDetector.ai is an AI-powered linguistic analysis tool
                    designed for educational, entertainment, and self-validation
                    purposes only.
                  </p>
                  <p data-id="element-2512">
                    <strong className="text-gray-400" data-id="element-2513">
                      Not Clinical Advice:
                    </strong>{' '}
                    While our algorithms are trained on behavioral patterns,
                    ToxicDetector does not provide medical, psychological, or
                    psychiatric diagnoses. It is not a substitute for
                    professional therapy or mental health counseling.
                  </p>
                  <p data-id="element-2514">
                    <strong className="text-gray-400" data-id="element-2515">
                      Not Legal Evidence:
                    </strong>{' '}
                    The "Forensic Dossier" and "Toxicity Scores" are digital
                    interpretations of text patterns and are not certified for
                    use as primary evidence in legal proceedings or divorce
                    litigation.
                  </p>
                  <p data-id="element-2516">
                    <strong className="text-gray-400" data-id="element-2517">Data Privacy:</strong> We
                    utilize AES-256 encryption. By using this tool, you confirm
                    you have the right to analyze the uploaded text.
                    ToxicDetector is not responsible for interpersonal outcomes
                    resulting from the use of our reports.
                  </p>
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>

        <div className="border-t border-gray-800 pt-8 mt-8" data-id="element-2518">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-xs font-mono text-gray-600 uppercase tracking-wide" data-id="element-2519">
            <p data-id="element-2520">
              © {new Date().getFullYear()} ToxicDetector. All rights reserved.
            </p>
            <div className="flex gap-8" data-id="element-2521">
              <a href="/privacy" className="hover:text-white transition-colors" data-id="element-2522">
                Privacy
              </a>
              <a href="/terms" className="hover:text-white transition-colors" data-id="element-2523">
                Terms
              </a>
              <a href="mailto:support@toxicdetector.com" className="hover:text-white transition-colors" data-id="element-2524">
                Support
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}